import { Panel } from '@shared/ui';

export function AvatarPage() {
  return (
    <div className="flex h-full items-center justify-center p-5">
      <Panel className="max-w-md text-center">
        <p className="text-sm text-text-secondary">
          Dedicated avatar configuration will live here once the Unity renderer integration begins.
          Until then, the avatar overlay controls are available from the{' '}
          <span className="text-text-primary">Preview</span> tab.
        </p>
      </Panel>
    </div>
  );
}
